import { render, staticRenderFns } from "./CheckDegreeFailure.vue?vue&type=template&id=2ec0c892&scoped=true"
import script from "./CheckDegreeFailure.vue?vue&type=script&lang=js"
export * from "./CheckDegreeFailure.vue?vue&type=script&lang=js"
import style0 from "./CheckDegreeFailure.vue?vue&type=style&index=0&id=2ec0c892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0c892",
  null
  
)

export default component.exports